module.exports = __webpack_public_path__ + "static/media/Menu-1.dcaf82bc.jpg";